import { pick, size } from 'lodash'

const unknownWordFormInitialValues = unknownWord => {
  const {
    value,
    context,
    posIndex,
    ingredientId,
    ingredientKeywordMatchType,
    dietId,
    languageId,
    allergenId,
  } = unknownWord

  const originalValue = context.substring(posIndex[0], posIndex[1])

  let htmlFormatContext

  if (originalValue === value) {
    const boldedValue = `${context.substring(0, posIndex[0])}${context
      .substring(posIndex[0], posIndex[1])
      .replace(originalValue, '<strong>$&</strong>')}${context.substring(
      posIndex[1],
      size(context),
    )}`

    htmlFormatContext = `<p>${boldedValue}</p>`
  } else {
    htmlFormatContext = `<p>${context.replace(
      value,
      '<strong>$&</strong>',
    )}</p>`
  }

  return {
    ...pick(unknownWord, [
      'originField',
      'context',
      'type',
      'isContextDependant',
    ]),
    context: htmlFormatContext,
    allergenId,
    dietId,
    ingredientId,
    languageId,
    ingredientKeywordMatchType,
  }
}

export default unknownWordFormInitialValues
